import styled from "styled-components";

export const StyledFooter = styled.footer`
  color: var(--dark--primary--text);

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-top: 5px;
  border-top: 1px solid var(--dark--green--50);

  height: 6.25rem;
  width: 100%;

  h1 {
    margin-left: 2rem;
  }

  .personalInfo {
    width: 60%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    section {
      margin-right: 2rem;
      margin-left: 3rem;
    }
  }

  .footerIconMenu {
    color: var(--dark--primary--text);
    width: 40px;
    height: 40px;
    margin-right: 1rem;
    margin-top: 1rem;
  }
`;
